import { searchResults } from '../../discovery'
import type { BillSummary } from '../../models'

/** Returns true when the query has at least 2 non-whitespace characters (mirrors Rust chars().count() >= 2 on trimmed). */
export function hasMeaningfulQuery(query: string): boolean {
  return query.trim().length >= 2
}

export function lookupResults(bills: BillSummary[], query: string, limit: number): BillSummary[] {
  if (!hasMeaningfulQuery(query)) {
    return []
  }
  return searchResults(bills, query, limit)
}
